import AssuredGiftsHeaderText from './AssuredGiftsHeaderText';

export { AssuredGiftsHeaderTextProps } from './AssuredGiftsHeaderText';

export default AssuredGiftsHeaderText;
